const DEFAULT_DEV_ORIGIN = 'http://localhost:5173';

export const getWebApiOrigin = (): string => {
  if (import.meta.env.PROD) {
    return '/';
  }

  return import.meta.env.VITE_DEV_ORIGIN || DEFAULT_DEV_ORIGIN;
};
